export default "__VITE_ASSET__nZIeCQX8__"